import { Swiper, SwiperSlide } from "swiper/react";
import NetworkMediaFile from "../image/NetworkMediaFile";
import clsx from "clsx";

export const OverFlowBannerSwiper = ({
  ls,
  onClick,
}: {
  ls?: MediaFile[];
  onClick?: () => void;
}) => {
  const className = "!h-[145px] sm:!h-[30rem] !w-full";

  if (ls?.length === 1) {
    return (
      <NetworkMediaFile
        className={className}
        file={ls[0]}
        onClick={onClick}
        fetchPriority="high"
        loading="eager"
        cdnParams={{ format: "webp" }}
      />
    );
  }
  return (
    <div className={clsx("flex justify-center overflow-hidden", className)}>
      {!!ls?.length && (
        <Swiper
          className={className}
          // spaceBetween={24}
          slidesPerView={1}
          navigation={false}
          pagination={false}
          autoplay={{ delay: 4000 }}
          loop={true}
        >
          {(ls ?? []).map((m, i) => (
            <SwiperSlide className={className} key={m.mediaFileId}>
              <NetworkMediaFile
                className={className}
                file={m}
                onClick={onClick}
                cdnParams={{ format: "webp" }}
                fetchPriority={i === 0 ? "high" : "low"}
                loading={i === 0 ? "eager" : "lazy"}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};
